export const reportToolbarStyles = {
  headerRow: {
    justify: "space-between",
    align: "flex-start",
    gap: 1,
    py: 0.5,
    flexWrap: "wrap",
  },
  toolbar: {
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    w: "100%",
    flexWrap: "wrap",
    borderRadius: "lg",
    p: 0,
  },
  menuList: {
    bg: "var(--bg-card)",
    borderColor: "var(--border-color)",
    boxShadow: "var(--shadow-light)",
    maxH: "18.75rem",
    overflowY: "auto",
    py: 1,
  },
  popoverContent: {
    bg: "var(--bg-card)",
    borderColor: "var(--border-color)",
    boxShadow: "var(--shadow)",
    borderRadius: "lg",
  },
  bodyCard: {
    bg: "var(--bg-card)",
    borderRadius: "lg",
    boxShadow: "var(--shadow-light)",
    border: "1px solid var(--border-color)",
    overflow: "hidden",
  },
};

export const reportButtonStyles = {
  base: {
    size: "sm",
    h: "34px",
    px: 3,
    borderRadius: "md",
    fontSize: "sm",
    fontWeight: "500",
  },
  primary: {
    bg: "var(--accent-primary)",
    color: "white",
    borderColor: "var(--accent-primary)",
    _hover: { bg: "#0b5ed7", borderColor: "#0b5ed7" },
  },
  secondary: {
    variant: "outline",
    bg: "var(--bg-card)",
    color: "var(--text-primary)",
    borderColor: "var(--border-color)",
    _hover: { bg: "var(--bg-hover)", borderColor: "var(--border-color)" },
  },
  ghost: {
    variant: "ghost",
    color: "var(--text-secondary)",
    _hover: { bg: "var(--bg-hover)" },
  },
};

export const getReportButtonProps = (variant = "secondary") => ({
  ...reportButtonStyles.base,
  ...(reportButtonStyles[variant] || reportButtonStyles.secondary),
});

export const buttonStyles = {
  filter: getReportButtonProps("secondary"),
  primary: getReportButtonProps("primary"),
  ghost: getReportButtonProps("ghost"),
};
